import React from 'react';
import { Container, Navbar, Nav } from 'react-bootstrap';
import { useLanguage } from '../contexts/LanguageContext';
import LanguageSwitcher from './LanguageSwitcher';

const NavigationBar: React.FC = () => {
  const { t } = useLanguage();

  return (
    <Navbar expand="lg" sticky="top" className="site-nav">
      <Container>
        <Navbar.Brand href="#home" className="d-flex align-items-center">
          <img
            src="/images/ellinor_logo.png"
            alt=""
            height="36"
            className="me-2"
          />
          Ellinor Kantedal
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto align-items-lg-center">
            <Nav.Link href="#home">{t('nav.home')}</Nav.Link>
            <Nav.Link href="#about">{t('nav.about')}</Nav.Link>
            <Nav.Link href="#services">{t('nav.experience')}</Nav.Link>
            <Nav.Link href="#contact">{t('nav.contact')}</Nav.Link>
            <div className="ms-lg-3 mt-2 mt-lg-0">
              <LanguageSwitcher />
            </div>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavigationBar;
